import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import { Checkbox, FormControl, FormControlLabel, FormHelperText, Grid, IconButton, Stack } from '@mui/material';

import PatientInfoPageApi from '../../../../../../../../api/patient/PatientInfoPageApi';
import NotificationManager from '../../../../../../../../common/notifications/NotificationManager';
import { NSPP_ENABLEMENT } from '../../../../../../../../services/i18n/namespaces';
import { PatientInfoContext } from '../../../PatientInfoContext';
import { validateEmail } from '../../../patientInfoService';

export default function NotificationsTab() {
  const { t } = useTranslation();
  const { patientInfo, setPatientInfo } = useContext(PatientInfoContext);

  const [currentReimbursementEmailNotificationsState, setCurrentReimbursementEmailNotificationsState] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);

  const reimbursementEmailNotifications = patientInfo?.reimbursementEmailNotifications;

  useEffect(() => {
    setCurrentReimbursementEmailNotificationsState(reimbursementEmailNotifications);
  }, [reimbursementEmailNotifications]);

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid size={6}>
        <FormControl error={showErrorMessage} required component="fieldset" sx={{ m: 1 }} variant="standard">
          <FormControlLabel
            value="top"
            control={
              <Checkbox
                checked={currentReimbursementEmailNotificationsState}
                onChange={({ target }) => setCurrentReimbursementEmailNotificationsState(target.checked)}
              />
            }
            label={t(`${NSPP_ENABLEMENT}:notifications.reimbursementEmailNotification`)}
          />
          {showErrorMessage && <FormHelperText>{t(`${NSPP_ENABLEMENT}:notofocations.emailEmptyError`)}</FormHelperText>}
        </FormControl>
      </Grid>
      <Grid size={6}>
        <Stack
          direction="row"
          spacing={1}
          sx={{
            justifyContent: 'flex-end'
          }}
        >
          <IconButton
            aria-label="save"
            disabled={currentReimbursementEmailNotificationsState === reimbursementEmailNotifications}
            color="primary"
            onClick={() => {
              if (
                patientInfo &&
                patientInfo.email &&
                patientInfo.email.length !== 0 &&
                validateEmail(patientInfo.email)
              ) {
                setShowErrorMessage(false);
                onSave();
              } else {
                setShowErrorMessage(true);
              }
            }}
            title={t('save')}
          >
            <SaveIcon />
          </IconButton>
          <IconButton
            aria-label="discard"
            disabled={currentReimbursementEmailNotificationsState === reimbursementEmailNotifications}
            color="primary"
            onClick={() => {
              setShowErrorMessage(false);
              setCurrentReimbursementEmailNotificationsState(reimbursementEmailNotifications);
            }}
            title={t('discardChanges')}
          >
            <CloseIcon data-testid="CloseIcon" />
          </IconButton>
        </Stack>
      </Grid>
    </Grid>
  );

  function onSave() {
    PatientInfoPageApi.updatePatientReimbursementEmailNotifications(
      patientInfo.id,
      currentReimbursementEmailNotificationsState
    )
      .then(() => {
        setPatientInfo(state => {
          return { ...state, reimbursementEmailNotifications: currentReimbursementEmailNotificationsState };
        });
      })
      .catch(() => {
        NotificationManager.error('Unable to save Reimbursement notifications');
      });
  }
}
